import { render, staticRenderFns } from "./updateModalComp.vue?vue&type=template&id=0df6b1f0&scoped=true"
import script from "./updateModalComp.vue?vue&type=script&lang=js"
export * from "./updateModalComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df6b1f0",
  null
  
)

export default component.exports